import { ProfileCustomValuesList } from "PFApp/components/custom_values_list";
import { PlaceholderCustomValuesList } from "PFApp/components/custom_values_list/placeholder_custom_values_list";
import { Flex, Inline } from "PFComponents/containers";
import { Icon } from "PFComponents/icon";
import { ProfileAvatar } from "PFComponents/profile_avatar/profile_avatar";
import { RenderIfVisible } from "PFComponents/render_if_visible";
import { SuspendedPill } from "PFComponents/suspended_pill";
import { Tooltip } from "PFComponents/tooltip";
import { Typography } from "PFComponents/typography";
import { getProfileName } from "PFCore/helpers/profile";
import { useTranslation } from "react-i18next";

import { useMatchProfileInfo } from "../../../../hooks/use_match_profile_info";
import { ShortlistForProfileButton } from "../../../../profiles/shortlist_for_profile";
import { ProfileCardProps } from "../../profile_card";
import css from "./profile_card_profile_info.module.scss";

export const ProfileCardProfileInfo = ({ profile, scrollableContainerRef }: ProfileCardProps) => {
  const { t } = useTranslation("profiles", { keyPrefix: "common" });

  const { headerInfo } = useMatchProfileInfo(profile);
  const formattedHeaderProfileInfo = headerInfo.map(({ value }) => value).join(", ");

  const profileName = getProfileName(profile);
  const { suspendedAt } = profile;

  return (
    <div className={css.wrapper}>
      <ProfileAvatar profile={profile} size={50} />
      <main className={css.main}>
        <Inline alignItems="center">
          <Typography variant="h4">{profileName}</Typography>
          {profile.placeholder && (
            <Tooltip content={t("placeholderProfile")}>
              <Flex center>
                <Icon name="placeholder-profile" size="lg" />
              </Flex>
            </Tooltip>
          )}
          {!!suspendedAt && <SuspendedPill suspendedAt={suspendedAt} />}
        </Inline>
        <Typography withMargin variant="labelRegular" className={css.matchInfo}>
          {formattedHeaderProfileInfo}
        </Typography>
        {profile.skills && (
          <div className={css.skills}>
            <RenderIfVisible
              placeholder={<PlaceholderCustomValuesList customValues={profile.skills} />}
              scrollableContainerRef={scrollableContainerRef}
            >
              <ProfileCustomValuesList
                profileId={profile.id}
                customFieldName="skills"
                customValues={profile.skills}
                limit={10}
              />
            </RenderIfVisible>
          </div>
        )}
      </main>
      <ShortlistForProfileButton profile={profile} />
    </div>
  );
};
